import { REPORTING_FIELD_LIST } from "./reportingFieldList.enum";

export const ReportingFieldList = [
  REPORTING_FIELD_LIST.NAME,
  REPORTING_FIELD_LIST.COUNTRY,
  REPORTING_FIELD_LIST.LOCATION,
  REPORTING_FIELD_LIST.BUILDING,
  REPORTING_FIELD_LIST.FLOOR,
  REPORTING_FIELD_LIST.WIRELESS_SYSTEM,
  REPORTING_FIELD_LIST.TYPE,
  REPORTING_FIELD_LIST.NUMBER_OF_DEVICES,
  REPORTING_FIELD_LIST.RESPONSIBLE_UNIT,
  REPORTING_FIELD_LIST.STATUS,
  REPORTING_FIELD_LIST.DESCRIPTION,
  REPORTING_FIELD_LIST.MANUFACTURER,
  REPORTING_FIELD_LIST.MODEL_NAME,
  REPORTING_FIELD_LIST.DRAFT,
  REPORTING_FIELD_LIST.OUTDOOR,
  REPORTING_FIELD_LIST.HEIGHT,
  REPORTING_FIELD_LIST.AXIS,
  REPORTING_FIELD_LIST.ROOM,
  REPORTING_FIELD_LIST.IMPLEMENTATION_START,
  REPORTING_FIELD_LIST.IMPLEMENTATION_END,
  REPORTING_FIELD_LIST.EXPIRATION_DATE,
  REPORTING_FIELD_LIST.OWNERS,
  REPORTING_FIELD_LIST.OPERATORS,
  REPORTING_FIELD_LIST.FREQUENCY_MANAGERS,
  REPORTING_FIELD_LIST.REQUESTER,
  REPORTING_FIELD_LIST.LAST_UPDATED_BY,
  REPORTING_FIELD_LIST.LAST_UPDATED_AT,
  REPORTING_FIELD_LIST.INTERFACE,
  REPORTING_FIELD_LIST.BANDWIDTH,
  REPORTING_FIELD_LIST.MAX_EIRP,
  REPORTING_FIELD_LIST.CHANNEL_SELECTION,
  REPORTING_FIELD_LIST.CHANNEL_NUMBER,
  REPORTING_FIELD_LIST.CHANNEL_CENTRAL_FREQUENCY,
  REPORTING_FIELD_LIST.CHANNEL_EIRP,
];